export default 'icon--x';